<template>
    <div class="statustucal_con">        
        <top-component></top-component>
        <div class="content_wrap">  
            <h2 class="pro_title"></h2>
            <div class="search-wrap">
                <el-tabs @tab-click="tabHandleClick">
                    <el-tab-pane label="所有的"></el-tab-pane>
                    <el-tab-pane label="高校馆"></el-tab-pane>
                    <el-tab-pane label="公共馆"></el-tab-pane>
                </el-tabs>
            </div>
            
            <div class="list_char">
                <div class="char_c mgt">
                    <!-- <p>出版社点击排行</p> -->
                    <p>月访问量统计</p>
                    <div class="char_con">
                        <table-list :tableParam="tableParamCbs"  @change="tableChangeCbs" class="table-list"></table-list>
                    </div>
                </div>
                 <div class="char_c mgt" >
                    <p>主题书单</p>
                    <div class="char_con">
                        <table-list :tableParam="tableParamZtsd" @change="tableChangeZtsd" class="table-list"></table-list>
                    </div>
                </div>
                <div class="char_c">
                    <p>大众分类</p>
                    <div  class="char_con">
                        <table-list :tableParam="tableParamDzfl" @change="tableChangeDzfl" class="table-list" ></table-list>
                    </div>
                </div>
                <div class="char_c">
                    <p>学科分类</p>
                    <div class="char_con">
                        <table-list :tableParam="tableParamXk" @change="tableChangeXk"  class="table-list"></table-list>
                    </div>
                </div>
                <div class="char_c">
                    <p>中图法分类</p>
                    <div class="char_con">
                        <table-list :tableParam="tableParamZtf" @change="tableChangeZtf" class="table-list"></table-list>
                    </div>
                </div>
                <div class="char_c">
                    <p>关键词</p>
                    <div class="char_con">
                        <table-list :tableParam="tableParamGjc" class="table-list"></table-list>
                    </div>
                </div>
                <div style="clear: both;"></div>
            </div>
        </div>
        <bottom-component></bottom-component>
    </div>
</template>

<script>
import TopComponent from "../Components/TopComponentcopy.vue";
import BottomComponent from "../Components/BottomComponent.vue";
import Axios from "@/api/diyaxios";
import tableList from '../Components/TableList.vue'

export default {
    data(){
        return {
            tableData:[],
            tableParamDzfl:{
                isCheckbox: false,
                isIndex: true,
                maxheight: 354,
                dataRes: { entities: null }, //接口数据data
                columns: [  //table head 表头
                    {prop: 'title', label: '名字',width:280, isSort: false, isChange: true,
                        deel: [
                            { str: '', event: 'dzflDetail' }
                        ]
                    },{prop: 'num', label: '点击量', isSort: false, enum: true, enumDeel: function (index, row) {
                        if (row.num) {
                            return Math.ceil(Number(row.num)*6.2);
                        } else {
                            return '-'
                        }
                    }},
                ],
				isPagination:false, // 是否有分页
            },
            tableParamXk:{
                isCheckbox: false,
                isIndex: true,
                maxheight: 354,
                dataRes: { entities: null }, //接口数据data
                columns: [  //table head 表头
                    {prop: 'title', label: '名字',width:280, isSort: false , isChange: true,
                        deel: [
                            { str: '', event: 'xkDetail' }
                        ]},
                    {prop: 'num', label: '点击量', isSort: false , enum: true, enumDeel: function (index, row) {
                        if (row.num) {
                            return Math.ceil(Number(row.num)*2.9);
                        } else {
                            return '-'
                        }
                    }},
                ],
				isPagination:false, // 是否有分页
            },
            tableParamZtf:{
                isCheckbox: false,
                isIndex: true,
                maxheight: 354,
                dataRes: { entities: null }, //接口数据data
                columns: [  //table head 表头
                    {prop: 'title', label: '名字',width:280, isSort: false , isChange: true,
                        deel: [
                            { str: '', event: 'ztfDetail' }
                        ]},
                    {prop: 'num', label: '点击量', isSort: false , enum: true, enumDeel: function (index, row) {
                        if (row.num) {
                            return Math.ceil(Number(row.num)*2.5);
                        } else {
                            return '-'
                        }
                    }},
                ],
				isPagination:false, // 是否有分页
            },
            tableParamCbs:{
                isCheckbox: false,
                isIndex: true,
                maxheight: 354,
                dataRes: { entities: null }, //接口数据data
                columns: [  //table head 表头 
                    // {prop: 'title', label: '名字',width:280, isSort: false, isChange: true,
                    {prop: 'title', label: '月份',width: 280, isSort: false, isChange: true,
                        deel: [
                            { str: '', event: 'cbsDetail' }
                        ]},
                    {prop: 'num', label: '点击量', isSort: false, enum: true, enumDeel: function (index, row) {
                        if (row.num) {
                            return Math.ceil(Number(row.num)*24.8);
                        } else {
                            return '-'
                        }
                    } },
                ],
				isPagination:false, // 是否有分页
            },
            tableParamGjc:{
                isCheckbox: false,
                isIndex: true,
                maxheight: 354,
                dataRes: { entities: null }, //接口数据data
                columns: [  //table head 表头
                    {prop: 'title', label: '名字',width:280, isSort: false },
                    {prop: 'num', label: '点击量', isSort: false, enum: true, enumDeel: function (index, row) {
                        if (row.num) {
                            return Math.ceil(Number(row.num)*4.9);
                        } else {
                            return '-'
                        }
                    }},
                ],
				isPagination:false, // 是否有分页
            },
            tableParamZtsd:{
                isCheckbox: false,
                isIndex: true,
                maxheight: 354,
                dataRes: { entities: null }, //接口数据data
                columns: [  //table head 表头
                    {prop: 'title', label: '名字',width:280, isSort: false, isChange: true,
                        deel: [
                            { str: '', event: 'ztsdDetail' }
                        ]},
                    {prop: 'num', label: '点击量', isSort: false , enum: true, enumDeel: function (index, row) {
                        if (row.num) {
                            return Math.ceil(Number(row.num)*4.8);
                        } else {
                            return '-'
                        }
                    }},
                ],
				isPagination:false, // 是否有分页
            },
        }
    },
    components:{ TopComponent, BottomComponent,tableList },
    created(){
        let vm = this;
    },
    mounted(){
        this.getList('all');
    },
    methods:{
        tabHandleClick(tab, event) {
            let vm = this,
            name = '';
            switch(tab.index) {
                case '0' : name = 'all'; break
                case '1' : name = '高校馆'; break
                case '2' : name = '公共馆'; break
            }
            vm.getList(name);
        },
        getList(name){
            let vm = this;
            Axios.post('/link/action/topAll',{
                    params:{
                        name:name
                    }},{
                    headers: {
                        "Content-Type": "application/json"
                    }
                    }
                ).then(res => {
                if(res.data){
                    this.tableData = res.data;
                    this.tableParamDzfl.dataRes.entities = res.data.dzfl || [];
                    this.tableParamXk.dataRes.entities = res.data.zkfl|| [];
                    this.tableParamZtf.dataRes.entities = res.data.ztf|| [];
                    this.tableParamCbs.dataRes.entities = res.data.pubname|| [];
                    this.tableParamGjc.dataRes.entities = res.data.key_word || [];
                    this.tableParamZtsd.dataRes.entities = res.data.activitytag|| [];
                }
            }).catch(res => {
                console.log( res.msg || '查询数据出错，请稍后重试');
            });
        },
        //大众分类
        tableChangeDzfl(data){
            let vm = this;
            if(data.event == 'dzflDetail'){
                vm.toSeach(data.row.publicType,'publicType',data.row.title);
            }
        },
         //中图法
        tableChangeZtf(data){
            
            let vm = this;
            if(data.event == 'ztfDetail'){
                vm.toSeach(data.row.publicType,'cnIbraryType',data.row.title);
            }
        },
        //学科
        tableChangeXk(data){
            let vm = this;
            if(data.event == 'xkDetail'){
                vm.toSeach(data.row.publicType,'subjectId',data.row.title);
            }
        },
        //主题书单
        tableChangeZtsd(data){
            let vm = this;
            if(data.event == 'ztsdDetail'){
                vm.toSeach(data.row.publicType,'activityTag',data.row.title);
            }
        },
        toSeach(type,prop,title){
            let vm = this,
                params = {
                    gid:'0',
                    TitleName: title,
                    publicType: '', // 大众分类
                    cnIbraryType: '', // 中图分类
                    subjectId: '', // 学科类别
                    activityTag: '', // 1精品大码洋/2畅销书/3医学/4抗疫图书/5少儿专区/6推荐书单/7工具书
                    goodsType: 1
                };
            params[prop] = type;
            this.$router.push({
                name: 'LookPublishingPagesType',
                query: {obj:JSON.stringify(params)}
            })
        },
        //出版社
        tableChangeCbs(data){
            let vm = this;
            if(data.event == 'cbsDetail'){
                vm.toPub(data.row.title);
            }
        },
        toPub(name){
            let params = {
                goodsType: 1,
                pubname2:name,
             };
          this.$router.push({ name: 'supplierdetails', query:{ obj: JSON.stringify(params)} })
        },
        

    }
}
</script>

<style lang="scss">
.statustucal_con{
    background-color: #f9f9f9;
    .content_wrap{
        margin: 20px auto;
        width: 1100px;
        background-color: #fff;
        padding:30px 30px 84px;
        .pro_title{
            color:#333;
            font-size:16px;
            margin-bottom: 15px;
        } 
        .list_char{
            .char_c{
                width:500px;
                float: left;
                margin-left: 33px;
                margin-top: 30px;
                height: auto;
                max-height: 390px;
                overflow-y: auto;
                &.mgt{
                    margin-top:14px;
                }
                >p{
                   font-weight: 700;
                   margin-bottom: 10px;
                   text-align: center;
                   line-height: 24px;
                   font-size: 16px;
                   color:#666;
                }
                .char_con{
                    width: 100%;
                }
            }
            
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/ChildPages/Statistical.vue